/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Header, AlertBar } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  headerContainer: {
    marginBottom: 16,
  },
  spacer: {
    marginBottom: 12,
  },
});

export namespace FormCardContent {
  export interface Props {
    children?: React.ReactNode;
    displayError?: string;
    formId: string;
    headerLabel?: JSX.Element;
    headerTitle: string;
  }
}

export const FormCardContent: React.FC<FormCardContent.Props> = ({
  children,
  displayError,
  formId,
  headerLabel,
  headerTitle,
}) => {
  return (
    <div>
      <div className={css(styles.headerContainer)}>
        <div className={css(styles.spacer)}>
          <Header colorName="NIGHT_90" size={2}>
            {headerTitle}
          </Header>
        </div>
        {headerLabel}
      </div>
      {displayError && (
        <div className={css(styles.spacer)}>
          <AlertBar id={`${formId}-error`} message={displayError} theme="error" />
        </div>
      )}
      {children}
    </div>
  );
};
